import React from "react";
import CheckoutBtn from "../../checkoutButton";
import styles from "./index.module.scss";
import AvatarFlipper from "../../avatar";

export default function CanCheckout({
  acctId,
  setHideInfo,
  isExpired,
  flipperData,
  type,
  isCoolDownActive = false
}: {
  acctId: string;
  setHideInfo: (hideInfo: boolean) => void;
  isExpired: boolean;
  type?: string;
  flipperData: any;
  isCoolDownActive?: boolean;
}) {
  return (
    <div className={styles.CanCheckout}>
      <AvatarFlipper owner={flipperData?.owner} />
      <CheckoutBtn
        isCoolDownActive={isCoolDownActive}
        acctId={acctId}
        setHideInfo={setHideInfo}
        isExpired={isExpired}
        flipperData={flipperData}
        type={type}
      />
    </div>
  );
}
